import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Store } from '@ngrx/store';
import { TreeNode, Filter, FilterType, FilterLogicaOperator, FilterKey, NodeType, FilterGroupLogicaOperator, FilterComparisonOperator, UnidadMedida, getUnidadMedida } from '../../models';
import { addSelectedFilter, changeUnidadMedida } from '../../actions';
import { FiltersService } from '../../services';
import { acabadoSelector, colorMaterialSelector, continenteSelector, disponibilidadSelector, espesorSelector, rangoPrecioSelector, tipoMaterialSelector, usoMaterialSelector } from '../../selectors'
import { getLanguage, getLanguageFromUrl, Language, LanguageId, changeUrlLanguage } from 'src/app/language';
import { togglShowSideFilter } from 'src/app/actions';
import { ModuleState } from 'src/app/state';


@Component({
  selector: 'side-filters',
  templateUrl: './side-filters.container.html',
  styleUrls: ['./side-filters.container.css']
})
export class SideFiltersContainer implements OnInit {
  language: Language;
  //@Output('onChangeLanguage') onChangeLanguage: EventEmitter<LanguageId> = new EventEmitter<LanguageId>();
  currentLanguage: LanguageId;
  languageId = LanguageId;
  treeSchema: TreeNode[] = [];
  unidadMedida = UnidadMedida;
  currentUnidadMedida: UnidadMedida;

  /*get language(): Language {
    return getLanguage(getLanguageFromUrl());
  }*/

  constructor(private store: Store, private filtersService: FiltersService) { }

  addfilter(filter: Filter): void {
    return this.store.dispatch(addSelectedFilter({ filter }))
  }

  orderParentNode(tree: TreeNode[]): TreeNode[] {
    return tree.sort((a: TreeNode, b:TreeNode) => a.rowNumber - b.rowNumber);
  }

  changeUnidadMedida(unidad: UnidadMedida): void {
    return this.store.dispatch(changeUnidadMedida({ unidad }))
  }

  /*togglSideFilters() {
    return this.store.dispatch(togglShowSideFilter())
  }*/

  selectLanguage(language: LanguageId): void {
    //return this.onChangeLanguage.emit(language);
    window.location.pathname = changeUrlLanguage(language);
  }
  
  /*getMenuLanguage(): string {
    if (this.currentLanguage == this.languageId.ENGLISH)
      return '';
    else
      return '/' + this.currentLanguage;
  }*/

  ngOnInit(): void {

    this.language = getLanguage(getLanguageFromUrl());
    this.currentLanguage = getLanguageFromUrl();

    this.store.select(tipoMaterialSelector).subscribe(tipos => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.TIPO_MATERIAL_FILTER_TITLE),
      ...[{name: this.language.TIPO_MATERIAL_FILTER_TITLE, rowNumber: 1, type: NodeType.PARENT,  children: [
        ...(tipos.map(tipo => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getTipoMaterialFilterNode(tipo)
          }
        }))
      ]}]
    ]);

    this.store.select(acabadoSelector).subscribe(acabados => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.ACABADO_MATERIAL_FILTER_TITLE),
      ...[{name: this.language.ACABADO_MATERIAL_FILTER_TITLE, rowNumber: 2, type: NodeType.PARENT, children: [
        ...(acabados.map(acabado => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getAcabadoFilterNode(acabado)
          }
        }))
      ]}]
    ]);

    this.store.select(usoMaterialSelector).subscribe(usos => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.USO_MATERIAL_FILTER_TITLE),
      ...[{name: this.language.USO_MATERIAL_FILTER_TITLE, rowNumber: 6, type: NodeType.PARENT, children: [
        ...(usos.map(uso => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getUsoMaterialFilterNode(uso)
          }
        }))
      ]}]
    ]);

    this.store.select(continenteSelector).subscribe(continentes => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.ORIGEN_MATERIAL_TITLE),
      ...[{name: this.language.ORIGEN_MATERIAL_TITLE, rowNumber: 7, type: NodeType.PARENT, children: [
        ...(continentes.map(continente => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getOrigenFilterNode(continente)
          }
        }))
      ]}]
    ]);

    this.store.select(colorMaterialSelector).subscribe(colores => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.COLOR_MATERIAL_TITLE),
      ...[{name: this.language.COLOR_MATERIAL_TITLE, rowNumber: 5, type: NodeType.PARENT, children: [
        ...(colores.map(color => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getColorFilterNode(color)
          }
        }))
      ]}]
    ]);

    this.store.select(espesorSelector).subscribe(espesores => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.ESPESOR_FILTER_TTILE),
      ...[{name: this.language.ESPESOR_FILTER_TTILE, rowNumber: 3, type: NodeType.PARENT, children: [
        ...(espesores.map(espesor => {
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getEspesorFilterNode(espesor)
          }
        }))
      ]}]
    ]);

    this.store.select(disponibilidadSelector).subscribe(disponibilidadList => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.DISPONIBILIDAD_FILTER_TITLE),
      ...[{name: this.language.DISPONIBILIDAD_FILTER_TITLE, rowNumber: 4, type: NodeType.PARENT, children: [
        ...(disponibilidadList.map(disponibilidad => {{
          return {
            type: NodeType.FILTER,
            filter: this.filtersService.getDisponibilidadFilterNode(disponibilidad)
          }
        }}))
      ]}]
    ])

    this.store.select(rangoPrecioSelector).subscribe(rangos => this.treeSchema = [
      ...this.treeSchema.filter(node => node.name !== this.language.RANGO_PRECIO_FILTER_TITLE),
      ...[{name: this.language.RANGO_PRECIO_FILTER_TITLE, rowNumber: 8, type: NodeType.PARENT, children: [
        ...(rangos.map(rango => {{
          return {
            type: NodeType.FILTER,
            icon: rango.ICONOURL,
            filter: this.filtersService.getRangoPrecioFilterNode(rango)
          }
        }}))
      ]}]
    ])

    this.store.select((state: ModuleState) => state.unidadMedida).subscribe(unidad => {
      this.currentUnidadMedida = unidad;
      this.treeSchema = [
      ...this.treeSchema.filter(node => node.rowNumber !== 9),
      ...[{
        name: getLanguage(getLanguageFromUrl()).MEDIDAS_TITLE, rowNumber: 9, type: NodeType.PARENT, children: [
          {
            name: getLanguage(getLanguageFromUrl()).MEDIDAS_ANCHO_TITLE + ` (${unidad === UnidadMedida.CM ? 'm' : '"'})`,
            stepsArray: [
              {value: unidad === UnidadMedida.CM ? 1 : 40, legend: unidad === UnidadMedida.CM ? 1 : 40},
              {value: unidad === UnidadMedida.CM ? 1.5 : 60, legend: unidad === UnidadMedida.CM ? 1.5 : 60},
              {value: unidad === UnidadMedida.CM ? 2 : 80, legend: unidad === UnidadMedida.CM ? 2 : 80},
              {value: unidad === UnidadMedida.CM ? 2.5 : 100, legend: unidad === UnidadMedida.CM ? 2.5 : 100},
              {value: unidad === UnidadMedida.CM ? 3 : 120, legend: unidad === UnidadMedida.CM ? 3 : 120},
              {value: unidad === UnidadMedida.CM ? 3.5 : 140, legend: unidad === UnidadMedida.CM ? 3.5 : 140}
            ],
            type: NodeType.FILTER,
            filter: {
              name: getLanguage(getLanguageFromUrl()).MEDIDAS_ANCHO_TITLE,
              value: 1,
              type: FilterType.RANGE,
              valueMax: UnidadMedida.CM ? 3.5 : 140,
              key: unidad === UnidadMedida.CM ? FilterKey.MEDIDA_ANCHURA : FilterKey.MEDIDA_ANCHURA_INCHES,
              logicalOperator: FilterLogicaOperator.AND,
              groupLogicalOperator: FilterGroupLogicaOperator.AND
            }

          },
          {
            name: getLanguage(getLanguageFromUrl()).MEDIDAS_ALTO_TITLE + ` (${unidad === UnidadMedida.CM ? 'm' : '"'})`,
            stepsArray: [
              {value: unidad === UnidadMedida.CM ? 1 : 40, legend: unidad === UnidadMedida.CM ? 1 : 40},
              {value: unidad === UnidadMedida.CM ? 1.5 : 60, legend: unidad === UnidadMedida.CM ? 1.5 : 60},
              {value: unidad === UnidadMedida.CM ? 2 : 80, legend: unidad === UnidadMedida.CM ? 2 : 80},
              {value: unidad === UnidadMedida.CM ? 2.5 : 100, legend: unidad === UnidadMedida.CM ? 2.5 : 100},
            ],
            type: NodeType.FILTER,
            filter : {
              name: getLanguage(getLanguageFromUrl()).MEDIDAS_ALTO_TITLE,
              type: FilterType.RANGE,
              value: 1,
              valueMax: UnidadMedida.CM ? 2.5 : 100,
              key: unidad === UnidadMedida.CM ? FilterKey.MEDIDA_ALTURA : FilterKey.MEDIDA_ALTURA_INCHES,
              logicalOperator: FilterLogicaOperator.AND,
              groupLogicalOperator: FilterGroupLogicaOperator.AND
            }

          },
          {
            name: getLanguage(getLanguageFromUrl()).SUPERFICIE + ` (${unidad === UnidadMedida.CM ? '㎡' : 'ft2'})`,
            stepsArray: [
              {value: unidad === UnidadMedida.CM ? 1 : 10, legend: unidad === UnidadMedida.CM ? 1 : 10},
              {value: unidad === UnidadMedida.CM ? 2 : 20, legend: unidad === UnidadMedida.CM ? 2 : 20},
              {value: unidad === UnidadMedida.CM ? 3 : 30, legend: unidad === UnidadMedida.CM ? 3 : 30},
              {value: unidad === UnidadMedida.CM ? 4 : 40, legend: unidad === UnidadMedida.CM ? 4 : 40},
              {value: unidad === UnidadMedida.CM ? 5 : 50, legend: unidad === UnidadMedida.CM ? 5 : 50},
              {value: unidad === UnidadMedida.CM ? 6 : 60, legend: unidad === UnidadMedida.CM ? 6 : 60},
              {value: unidad === UnidadMedida.CM ? 7 : 70, legend: unidad === UnidadMedida.CM ? 7 : 70},
            ],
            type: NodeType.FILTER,
            filter : {
              name: getLanguage(getLanguageFromUrl()).SUPERFICIE,
              type: FilterType.RANGE,
              value: 1,
              valueMax: UnidadMedida.CM ? 7 : 70,
              key: unidad === UnidadMedida.CM ? FilterKey.MEDIDA_SUPERFICIE : FilterKey.MEDIDA_SUPERFICIE_INCHES,
              logicalOperator: FilterLogicaOperator.AND,
              groupLogicalOperator: FilterGroupLogicaOperator.AND
            }

          },
        ]
      }]
    ]})

    this.treeSchema.push(BOOKMATCH_FILTER_NODE)
  }
}

const BOOKMATCH_FILTER_NODE: TreeNode = {
  type: NodeType.FILTER,
  rowNumber: 10,
  name: 'BOOKMATCH',
  filter: {
    name: 'BOOKMATCH',
    value: 1,
    type: FilterType.CHECK_BOX,
    key: FilterKey.BOOKMATCH,
    logicalOperator: FilterLogicaOperator.AND,
    comparator: FilterComparisonOperator.EQUAL,
    groupLogicalOperator: FilterGroupLogicaOperator.AND
  }
}
